import React, { useState, useRef, useMemo, useCallback, useEffect } from 'react'
import { Dialog, DialogContent, DialogActions, Button, Box } from '@mui/material'
import ControlPanel from '../pdfReader/ControlPanel'
import PDFReaderNoControlPanel from '../pdfReader/PDFReaderNoControlPanel'
import Loading from '../common/Loading'

function PreviewFileDialog({ open, onClose, previewFile }) {
  const [scale, setScale] = useState(1)
  const [pageNumber, setPageNumber] = useState(1)
  const [numPages, setNumPages] = useState(null)
  const lastFileRef = useRef(null)
  const fileUrlRef = useRef(null)

  const fileUrl = useMemo(() => {
    if (!previewFile) return null

    let blob = null
    if (previewFile instanceof Blob) {
      blob = previewFile
    } else if (previewFile instanceof ArrayBuffer && previewFile.byteLength > 0) {
      blob = new Blob([previewFile], { type: 'application/pdf' })
    } else {
      return null
    }

    const url = URL.createObjectURL(blob)

    if (fileUrlRef.current) {
      URL.revokeObjectURL(fileUrlRef.current)
    }
    fileUrlRef.current = url

    return url
  }, [previewFile])

  useEffect(() => {
    return () => {
      if (fileUrlRef.current) {
        URL.revokeObjectURL(fileUrlRef.current)
      }
    }
  }, [])

  const onDocumentLoadSuccess = useCallback(
    ({ numPages }) => {
      setNumPages(numPages)

      if (lastFileRef.current !== previewFile) {
        setPageNumber(1)
        lastFileRef.current = previewFile
      }
    },
    [previewFile]
  )

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth='md'>
      <DialogContent dividers sx={{ display: 'flex', flexDirection: 'column', p: 0, flex: 1, minHeight: 0 }}>
        {fileUrl ? (
          <>
            <Box
              sx={{
                position: 'sticky',
                top: 0,
                zIndex: 10,
                borderBottom: '1px solid #ccc',
                backgroundColor: 'background.paper',
                p: 1,
                flexShrink: 0,
                display: 'flex',
                justifyContent: 'center',
                height: 64,
                alignItems: 'center',
                boxSizing: 'border-box'
              }}
            >
              <ControlPanel
                scale={scale}
                setScale={setScale}
                pageNumber={pageNumber}
                setPageNumber={setPageNumber}
                numPages={numPages}
                filename={previewFile?.name || 'file.pdf'}
                file={fileUrl}
              />
            </Box>

            <Box sx={{ flex: 1, minHeight: 0, overflowY: 'auto' }}>
              <PDFReaderNoControlPanel
                url={fileUrl}
                pageNumber={pageNumber}
                scale={scale}
                onLoadSuccess={onDocumentLoadSuccess}
              />
            </Box>
          </>
        ) : (
          <Box
            sx={{
              display: 'flex',
              flex: 1,
              height: '100%',
              minHeight: '100px',
              alignItems: 'center',
              justifyContent: 'center'
            }}
          >
            <Loading />
          </Box>
        )}
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose}>Fermer</Button>
      </DialogActions>
    </Dialog>
  )
}

export default PreviewFileDialog
